import Typography from 'material-ui/Typography';
import { hideSnackbar } from '../../store/Snackbar/snackbar.actions';
import {
  getSnackbarState,
  SnackbarState,
} from '../../store/Snackbar/snackbar.reducer';
import { default as appStyles, StyleProps } from '../../utils/style';
import * as React from 'react';
import { withStyles } from 'material-ui/styles';
import Snackbar from 'material-ui/Snackbar';
import { SyntheticEvent } from 'react';
import { AppState } from '../../store/reducers';
import { connect } from 'react-redux';
import ErrorIcon from 'material-ui-icons/Error';
import WarningIcon from 'material-ui-icons/Warning';
import DoneIcon from 'material-ui-icons/Done';
import CloseIcon from 'material-ui-icons/Close';
import IconButton from 'material-ui/IconButton';

const styleSheet = {
  ...appStyles,
  message: {
    color: 'rgba(0, 0, 0, 0.7)',
  },
};

interface OwnProps {}
interface State {}
interface StateProps {
  snackbar: SnackbarState;
}

type Props = StateProps & typeof mapDispatchToProps & OwnProps & StyleProps;

class InfoSnackbar extends React.PureComponent<Props, State> {
  private handleRequestClose = (event: SyntheticEvent<any>, reason: string) => {
    const { onSnackbarHide } = this.props;
    if (reason === 'clickaway') {
      return;
    }
    onSnackbarHide();
  };

  public render() {
    const {
      classes,
      snackbar: { message, open, type },
    } = this.props;
    return (
      <div>
        <Snackbar
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          open={open}
          autoHideDuration={3e3}
          onClose={this.handleRequestClose}
          SnackbarContentProps={{ 'aria-describedby': 'message-id' }}
          style={{ zIndex: 99999 }}
          message={
            <div style={{ paddingRight: 15, ...classes.messageContainer }}>
              <span
                style={{
                  verticalAlign: 'middle',
                  display: 'inline-block',
                  marginRight: 5,
                }}
              >
                {type === 'error' && <ErrorIcon color="error" />}
                {type === 'warning' && <WarningIcon color="error" />}
                {type === 'success' && <DoneIcon color="primary" />}
              </span>
              <Typography
                className={classes.message}
                style={{ display: 'inline' }}
                type="body2"
              >
                {message}
              </Typography>
            </div>
          }
          action={[
            <IconButton
              key="close"
              color="inherit"
              className={classes.close}
              onClick={this.props.onSnackbarHide}
              style={{ position: 'absolute', top: 0, right: 0 }}
            >
              <CloseIcon className={classes.icon} />
            </IconButton>,
          ]}
        />
      </div>
    );
  }
}

function mapStateToProps(state: AppState, ownProps: OwnProps) {
  return {
    snackbar: getSnackbarState(state),
  };
}

const mapDispatchToProps = {
  onSnackbarHide: hideSnackbar,
};

export default withStyles(styleSheet)(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(InfoSnackbar)
);



// WEBPACK FOOTER //
// ./src/components/InfoSnackbar/index.tsx